import { createSlice } from '@reduxjs/toolkit';

const interactionSlice = createSlice({
    name: 'interaction',
    initialState: {
        interactions: [],
        sort: "desc",
        searchResult: [],
        current: null,
        showSearch: false,
        searchText: "",
        currentHistory: null,
        unreadMessages: 0
    },
    reducers: {

        addInteraction: (state, action) => {
            if (action.payload) {

                if (action.payload.interactionType === "chat") {
                    let lastMessage = action.payload.messages.filter(x => x.type === "U").pop(),
                        unreadMessages = action.payload.messages.filter(x => x.type === "U" && !x.seen).length;

                    if (!action.payload.track) {
                        action.payload.track = { location: "" };
                    }

                    let c = {
                        id: action.payload.id,
                        name: action.payload.fullname || action.payload.name,
                        lastMessage: "",
                        messages: action.payload.messages,
                        unreadMessages: unreadMessages,
                        channel: action.payload.type.toLowerCase(),
                        date: action.payload.date,
                        agent: action.payload.agent,
                        group: action.payload.group,
                        phone: action.payload.phone,
                        email: action.payload.email,
                        userId: action.payload.pin,
                        image: action.payload.image,
                        hasHistory: action.payload.hasHistory || false,
                        guid: action.payload.guid,
                        videoCallMessage: action.payload.videoCallMessage,
                        interactionType: action.payload.interactionType,
                        contactUrl: action.payload.contactUrl,
                        contactProcessed: action.payload.contactProcessed,
                        from: action.payload.from,
                        track: action.payload.track,
                        closed: false,
                        campaignId: action.payload.campaignId,
                        groupId: action.payload.groupId,
                        aiTranslation: action.payload.aiTranslation,
                        pendingTransfer: false,
                        contacts: action.payload.contacts,
                        bookId: action.payload.bookId,
                        onHold: action.payload.onHold,
                        color: action.payload.color
                    };

                    if (lastMessage)
                        c.lastMessage = lastMessage.text;

                    if (!state.interactions) {
                        state.interactions = [c];
                    } else {
                        let exists = state.interactions.find(x => x.id === action.payload.id);
                        if (!exists) {
                            state.interactions.push(c);
                        } else {
                            let current = state.interactions.find(x => x.id === action.payload.id);

                            state.interactions = state.interactions.filter(x => x.id !== action.payload.id);

                            if (current) {
                                current.closed = false;
                            }

                            if (state.current != null && state.current.id === current.id)
                                state.current = c;

                            state.interactions.push(c);
                            state.searchResult = filter(state.interactions, state.searchText);
                            state.searchResult = order(state.searchResult, state.sort);
                        }
                    }

                } else {

                    if (action.payload.activeCallGUID) {
                        var date = new Date(new Date().getTime() - (action.payload.time * 1000))
                        let c = {
                            id: action.payload.activeCallGUID || "1",
                            name: action.payload.partyName || "unknown",
                            phone: action.payload.party || "",
                            status: action.payload.ctiStatus,
                            group: "RANDOM", // ! NEEDS TO BE FIXED
                            channel: "phone",
                            inbound: action.payload.inbound,
                            recording: action.payload.recordingStatus === "RECORDING",
                            time: action.payload.time,
                            date: date.toISOString()
                        };

                        if (!state.interactions) {
                            state.interactions = [c];
                        } else {
                            let exists = state.interactions.find(x => x.id === action.payload.activeCallGUID);
                            if (!exists) {
                                state.interactions.push(c);
                            }
                            else {
                                exists.status = action.payload.ctiStatus;

                                if (exists.id === state.current.id)
                                    state.current = c;

                                if (exists.status === "HUNGUP") {
                                    state.interactions = state.interactions.filter(x => x.id !== exists.id);
                                    state.searchResult = state.searchResult.filter(x => x.id !== exists.id);
                                    if (state.current !== null && exists.id === state.current.id)
                                        state.current = null;
                                }

                            }
                        }
                    } else {
                        state.interactions = state.interactions.filter(x => x.channel !== "phone");
                        state.searchResult = state.searchResult.filter(x => x.channel !== "phone");
                        if (state.current != null && state.current.channel === "phone")
                            state.current = null;
                    }
                }

                state.searchResult = filter(state.interactions, state.searchText);
                state.searchResult = order(state.searchResult, state.sort);
                state.unreadMessages = countUnread(state.interactions);

            }

        },

        addMessage: (state, action) => {
            if (action.payload) {
                let current = state.interactions.find(x => x.id === action.payload.id);

                state.interactions = state.interactions.filter(x => x.id !== action.payload.id);

                if (current) {
                    current.lastMessage = action.payload.text;
                    current.messages.push(action.payload);
                }

                if (state.current !== null && current && state.current.id === current.id)
                    state.current.messages.push(action.payload);
                else if (current)
                    current.unreadMessages += 1;

                if (current)
                    state.interactions.push(current);

                state.searchResult = filter(state.interactions, state.searchText);
                state.searchResult = order(state.searchResult, state.sort);
                state.unreadMessages = countUnread(state.interactions);
            }

        },

        selectInteraction: (state, action) => {
            let current = state.interactions.find(x => x.id === action.payload);
            current.messages.forEach((v, i) => {
                v.seen = true;
            });
            state.interactions = state.interactions.filter(x => x.id !== action.payload);
            current.unreadMessages = 0;
            state.interactions.push(current);
            state.current = current;

            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
            state.unreadMessages = countUnread(state.interactions);
        },

        addHistoryMessages: (state, action) => {
            if (action.payload) {
                let current = state.interactions.find(x => x.id === action.payload.id);
                if (current) {
                    current.messages = action.payload.messages.concat(current.messages);
                }
                //*update current conversation
                if (state.current.id === current.id)
                    state.current.messages = action.payload.messages.concat(state.current.messages);
            }
        },

        search: (state, action) => {
            state.searchText = action.payload;
            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
            state.unreadMessages = countUnread(state.interactions);
        },

        sort: (state, action) => {
            state.sort = state.sort !== "desc" ? "desc" : "asc";
            state.searchResult = order(state.searchResult, state.sort);
        },

        closeConversation: (state, action) => {
            let current = state.interactions.find(x => x.id === action.payload);

            state.interactions = state.interactions.filter(x => x.id !== action.payload);

            if (!current.pendingTransfer) {
                if (current && current.channel !== "mail") {
                    current.closed = true;
                    state.interactions.push(current);
                }

                if (state.current !== null && state.current.id === current.id)
                    state.current = null;
            } else {
                if (state.current.id === current.id)
                    state.current = null;
            }

            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
        },

        changeShowSearch: (state, action) => {
            state.showSearch = !state.showSearch;
        },

        setSearchText(state, action) {
            state.searchText = action.payload;
        },

        selectHistoryIntercation: (state, action) => {
            state.currentHistory = action.payload;
        },
        updateTracking: (state, action) => {
            if (action.payload) {
                let current = state.interactions.find(x => x.id === action.payload.token);

                state.interactions = state.interactions.filter(x => x.id !== action.payload.token);

                if (current) {
                    current.track.location = action.payload.location;
                    current.messages.push(action.payload);
                }
                if (state.current != null && state.current.id === current.id)
                    state.current.track.location = action.payload.location;

                state.interactions.push(current);
                state.searchResult = filter(state.interactions, state.searchText);
                state.searchResult = order(state.searchResult, state.sort);
                state.unreadMessages = countUnread(state.interactions);

            }

        },
        deselectInteraction: (state, action) => {
            state.current = null;
        },
        setContactProcessed: (state, action) => {
            if (action.payload) {
                let current = state.interactions.find(x => x.id === action.payload);
                state.interactions = state.interactions.filter(x => x.id !== action.payload);

                if (current)
                    current.contactProcessed = true;

                if (state.current !== null && current && state.current.id === current.id)
                    state.current.contactProcessed = true;

                if (current)
                    state.interactions.push(current);
            }

        },
        closeConversationByAgent: (state, action) => {
            state.interactions = state.interactions.filter(x => x.id !== action.payload);
            state.searchResult = state.searchResult.filter(x => x.id !== action.payload);
            if (state.current.id === action.payload)
                state.current = null;
        },
        toggleAITranslation: (state, action) => {
            state.current.aiTranslation = !state.current.aiTranslation;

            state.interactions = state.interactions.filter(x => x.id !== state.current.id);
            state.interactions.push(state.current);
            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
        },
        updateMessages: (state, action) => {
            state.current.messages = action.payload;
            state.interactions = state.interactions.filter(x => x.id !== state.current.id);
            state.interactions.push(state.current);
            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
        },
        setPendingTransfer: (state, action) => {
            state.current.pendingTransfer = action.payload;
            state.interactions = state.interactions.filter(x => x.id !== state.current.id);
            state.interactions.push(state.current);
            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
        },
        setConverastionBookId: (state, action) => {

            if (state.current.contacts !== null && state.current.contacts.length > 1) {
                state.current.contacts = state.current.contacts.filter(x => parseInt(x.contactId) === action.payload);
            } else {
                state.current.contacts = [{
                    contactId: action.payload,
                    name: "",
                    company: "",
                    mail: "",
                    phone: "",
                    party: ""
                }];
            }

            state.current.bookId = action.payload;
            state.interactions = state.interactions.filter(x => x.id !== state.current.id);
            state.interactions.push(state.current);
            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
        },
        setContacts: (state, action) => {
            state.current.contacts = action.payload;
        },
        putOnHold: (state, action) => {
            state.current.onHold = action.payload;
            state.interactions = state.interactions.filter(x => x.id !== state.current.id);
            state.interactions.push(state.current);
            state.searchResult = filter(state.interactions, state.searchText);
            state.searchResult = order(state.searchResult, state.sort);
            if (action.payload)
                state.current = null;
        }

    }
});

function filter(arr, text) {
    let ret = arr;

    if (arr != null && arr.length > 0 && text != null && text.length > 0)
        ret = arr.filter(x => x.name.toLowerCase().indexOf(text.toLowerCase()) > -1);

    return ret;
}

function order(arr, dir) {
    if (dir === "desc")
        arr.sort((a, b) => -a.date.localeCompare(b.date));
    else
        arr.sort((a, b) => a.date.localeCompare(b.date));
    return arr;
}

function countUnread(arr) {
    let unreadMessages = arr.reduce((pv, cv) => pv + cv.unreadMessages, 0);
    console.log("unreadMessages" + unreadMessages);
    return unreadMessages;
}
export default interactionSlice.reducer
export const {
    addInteraction,
    addMessage,
    selectInteraction,
    search,
    sort,
    addHistoryMessages,
    closeConversation,
    changeShowSearch,
    setSearchText,
    selectHistoryIntercation,
    updateTracking,
    deselectInteraction,
    markAsSeen,
    setContactProcessed,
    closeConversationByAgent,
    toggleAITranslation,
    updateMessages,
    setPendingTransfer,
    setConverastionBookId,
    setContacts,
    putOnHold
} = interactionSlice.actions;
